<template>
  <Layout>
    <b-container>
      <PageHeader
        :title="pageTitle"
        :subtitle="pageSubtitle"
        :items="breadCrumb"
      />
      <b-card class="mt-2">
        <carousel :per-page="1" :navigate-to="slide" @page-change="pagechange">
          <slide v-for="(rate, i) in areasChangesToRate" :key="`slide-${i}`">
            <b-card class="border border-secondary">
              <b-row>
                <b-col cols="12" sm="12" md="6">
                  <b-row>
                    <b-col class="mt-2" cols="12">
                      <span class="font-weight-bold border-bottom border-primary text-primary">
                        {{ rate.changeName }}
                      </span>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <b-col cols="12">
                      <span>
                        {{ rate.changeDescription }}
                      </span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col class="mt-2" cols="12" sm="12" md="6">
                  <b-row>
                    <b-col cols="12">
                      <span class="font-weight-bold border-bottom border-primary text-primary">
                        Ámbito: {{ rate.areaName }}
                      </span>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="12">
                  <b-form-textarea
                    v-model="rateDescription"
                    placeholder="Por favor escriba una respuesta"
                    :state="error"
                    type="text"
                  >
                  </b-form-textarea>
                </b-col>
              </b-row>
              <b-row align-h="between" class="mt-1">
                <b-col cols="12" sm="12" md="6" lg="2">
                  <b-button
                    block
                    :disabled="slide === 0"
                    variant="secondary"
                    @click="back"
                  >
                    Atrás
                  </b-button>
                </b-col>
                <b-col cols="12" sm="12" md="6" lg="3">
                  <b-button
                    block
                    variant="primary"
                    :disabled="loading || lockContinueBtn"
                    @click="
                      saveAndContinue(
                        rate.changeUrl,
                        rate.ambitUrl,
                        rate.projectUrl
                      )
                    "
                  >
                    Guardar y continuar
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </slide>
        </carousel>
      </b-card>
    </b-container>
  </Layout>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'
export default {
  name: 'ExpertAreaRatePage',
  components: {
    carousel: Carousel,
    slide: Slide,
  },
  data() {
    return {
      projectId: '',
      profileId: '',
      pageTitle: '',
      pageSubtitle: '',
      slide: 0,
      rateDescription: '',
      error: null,
      profileUrl: '',
      loading: false,
      lockContinueBtn: false,
    }
  },
  computed: {
    ...mapGetters({
      areasToRate: 'expert/areasToRate',
      changesToRate: 'expert/changesToRate',
      projects: 'expert/projects',
      session: 'auth/currentSession',
      areasRated: 'expert/areasRated',
    }),
    isPublicProject() {
      return this.session && this.session.publicProject
    },
    breadCrumb() {
      const projectId = this.projectId
      const breadCrumb = [
        {
          text: 'Gestionar Proyecto',
          // to: `/public_project/${projectId}/`,
          to: `/expert/project/${projectId}/detail`
        },
        { text: 'Calificar Variables Estratégicas', active: true },
      ]
      if (!this.isPublicProject) {
        // breadCrumb.forEach(el => {
        //   if(el.text === 'Gestionar Proyecto'){
        //     el.to = `/expert/project/${projectId}/detail`
        //   }
        // });
        breadCrumb.unshift(
          { text: 'Home', to: '/' },
          { text: 'Mis Proyectos', to: '/expert/projects' }
        )
      }
      return breadCrumb
    },
    // breadCrumb() {
    //   const projectId = this.projectId
    //   return [
    //     { text: 'Home', to: '/' },
    //     { text: 'Mis Proyectos', to: '/expert/projects' },
    //     { text: 'Gestionar Proyecto', to: `/expert/project/${projectId}/detail` },
    //     { text: 'Calificar Variables Estratégicas', active: true }
    //   ]
    // },
    areasChangesToRate() {
      let array = []
      if (!this.areasToRate) return
      if (this.areasToRate.length > 0 && this.changesToRate.length > 0) {
        this.areasToRate.forEach((area) => {
          this.changesToRate.forEach((change) => {
            const rateObj = {
              changeId: change.id,
              changeName: change.name,
              changeDescription: change.description,
              changeUrl: change.url,
              areaId: area.id,
              areaName: area.name,
              ambitUrl: area.url,
              projectUrl: area.project,
            }
            array.push(rateObj)
          })
        })
      }

      return array
    },
  },
  watch: {
    projects: {
      deep: true,
      handler(val, oldVal) {
        if (val.results.length !== oldVal.results.length) {
          this.setVars()
        }
      },
    },
    areasChangesToRate(newVal, oldVal) {
      if (newVal && newVal.length !== oldVal.length) {
        this.checkSavedDecription()
      }
    },
    areasRated: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal.results.length !== oldVal.results.length) {
          this.checkSavedDecription()
        }
      },
    },
    slide(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkSavedDecription()
      }
    },
  },
  created() {
    this.projectId = this.$route.params.project_id
    this.profileId = this.$route.params.profile_id
    this.init()
    this.setVars()
    this.checkSavedDecription()
  },
  methods: {
    init() {
      this.$store.dispatch('expert/fetchRatedAreas', {
        project: this.projectId,
        profile: this.profileId,
      })
      this.$store.dispatch('expert/fetchAreasToRate', this.projectId)
      const username = this.session.user.username
      this.$store.dispatch('expert/fetchProjects', username)
    },
    setVars() {
      const project = this.projects.results.find(
        (p) => p.project.id === parseInt(this.projectId, 10)
      )
      if (project) {
        this.pageTitle = project.project.name
        this.pageSubtitle = project.project.description
        this.profileId = project.id
        this.profileUrl = project.url
      }
    },
    checkSavedDecription() {
      const ratedData = this.checkIfNewOrUpdate()
      if (ratedData) {
        this.rateDescription = ratedData.description
        return
      }
      this.rateDescription = ''
    },
    checkIfNewOrUpdate() {
      if (!this.areasChangesToRate) return
      const actualData = this.areasChangesToRate[this.slide]
      return this.areasRated.results.find(
        (rated) =>
          rated.change === actualData.changeUrl &&
          rated.ambit === actualData.ambitUrl
      )
    },
    saveAndContinue(changeUrl, ambitUrl, projectUrl) {
      if (this.rateDescription === '') {
        this.error = false
        return
      }
      const ratedData = this.checkIfNewOrUpdate()

      this.loading = true
      this.error = null
      const payload = {
        id: null,
        change: changeUrl,
        ambit: ambitUrl,
        project: projectUrl,
        profile: this.profileUrl,
        description: this.rateDescription,
        callback: this.continue,
      }
      if (ratedData) {
        payload.id = ratedData.id
        this.$store.dispatch('expert/updateRateChangeArea', payload)
        return
      }
      this.$store.dispatch('expert/rateChangeArea', payload)
    },
    continue() {
      this.rateDescription = ''
      this.loading = false
      this.slide = this.slide + 1
      this.$store.dispatch('expert/fetchRatedAreas', {
        project: this.projectId,
        profile: this.profileId,
      })
    },
    back() {
      this.rateDescription = ''
      this.slide = this.slide - 1
      this.loading = false
      this.lockContinueBtn = false
    },
    pagechange(page) {
      if (page >= this.areasChangesToRate.length) {
        this.$store.dispatch('utils/message', {
          type: 'success',
          title: 'Terminado',
          text: 'Se han calificado todos los ámbitos',
        })
        this.lockContinueBtn = true
        return
      }
      this.lockContinueBtn = false
      this.loading = false
      this.slide = page
    },
  },
}
</script>

<style lang="scss" scoped></style>
